import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { Trans } from 'react-i18next';

const CustomImage = styled('img')({
  width: '100%',
  height: 'auto',
  display: 'block',
  objectFit: 'contain',
  borderRadius: '16px',
});
function EnabledRouteMap({
  urlMap,
  altImg,
  handleError,
  handleLoad,
  routeType,
}) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <CustomImage
        src={urlMap}
        alt={altImg}
        onError={handleError}
        onLoad={handleLoad}
      />
      <Typography sx={{ fontSize: 14 }}>
        <Trans
          i18nKey={`routes.info.map_footer.${routeType}`}
          ns="description"
          components={[<strong />, <strong />]}
        />
      </Typography>
    </Box>
  );
}

export default EnabledRouteMap;
